import { QueryClient } from "react-query";

export enum QueryKeys {
  MembershipInfo = "MEMBERSHIP_INFO",
  Notifications = "NOTIFICATIONS",
  UserCardInfo = "USER_CARD_INFO",
}

export const queryClient = new QueryClient();
